import type { ReactNode } from 'react';

import { Label } from '@parrot-software/design-system';
import { cn } from '@parrot-software/utils';

export type FieldLabelProps = {
  children: ReactNode;
  className?: string;
  htmlFor: string;
  /** Draws the red asterisk that marks the field as required. */
  isRequired?: boolean;
};

/**
 * The label of a field of the wizards. It exists so the required mark is red and the same width
 * everywhere, instead of being an asterisk typed at the end of each translated string.
 *
 * @param {FieldLabelProps} props - Component properties
 */
export const FieldLabel = ({ children, className, htmlFor, isRequired }: FieldLabelProps) => (
  <Label className={cn('text-sm font-medium text-foreground', className)} htmlFor={htmlFor}>
    {children}
    {isRequired && (
      <span aria-hidden className="text-destructive">
        {' '}
        *
      </span>
    )}
  </Label>
);
